import { Card } from "@/components/ui/Card";
import { PageWrapper } from "@/components/ui/PageWrapper";
import { Flex } from "@givenwell/components";
import { createFileRoute } from "@tanstack/react-router";
import { AddCalendarModal } from "./AddCalendarModal";
import { CalendarTableLoader } from "./CalendarTable";

export const Route = createFileRoute("/supplier/$supplierId/settings/calendars/")({
  component: CalendarSettings,
});

function CalendarSettings() {
  const { supplierId } = Route.useParams();

  return (
    <PageWrapper
      title="Calendars"
      subTitle="Manage your calendars for bookings and availability."
      maxWidth={1400}
      rightContent={<AddCalendarModal supplierId={supplierId} />}
    >
      <Flex css={{ flexDirection: "column", items: "flex-start" }}>
        <Card css={{ width: "100%", py: 2 }}>
          <CalendarTableLoader supplierId={supplierId} />
        </Card>
      </Flex>
    </PageWrapper>
  );
}
